import React from 'react';
import { Route, Switch } from 'wouter';
import QuizLive from './components/QuizLive';
import QuizWrapper from './components/QuizWrapper';
import QuizAdminStatusProvider from './providers/QuizAdminStatusProvider';
import QuizInstanceStatusProvider from './providers/QuizInstanceStatusProvider';
import QuizInstanceAdminStatusProvider from './providers/QuizInstanceAdminStatusProvider';
import CourseSessionProvider from './providers/CourseSessionProvider';
import CourseSessionJoin from './components/CourseSessionJoin';
import MainPage from './components/MainPage';
import { absURL } from './utils';

import './style/App.css';
import './style/bootstrap.css';
import './style/font-awesome.min.css';
import "react-image-gallery/styles/css/image-gallery.css";

import AdminQuizList from './components/AdminQuizList';
import AdminGroupOverview from './components/AdminGroupOverview';
import AdminQuizEdit from './components/AdminQuizEdit';
import QuizQuestionList from './components/AdminQuizQuestionList';
import AdminQuizInstanceList from './components/AdminQuizInstanceList';
import AdminQuizQuestionCreate from './components/AdminQuizQuestionCreate';
import AdminQuizQuestionEdit from './components/AdminQuizQuestionEdit';
import AdminQuizCreate from './components/AdminQuizCreate';
import AdminOrgSettings from './components/AdminOrgSettings';
import AdminSuperOrganizationList from './components/AdminSuperOrganizationList';
import AdminSuperOrganizationDetail from './components/AdminSuperOrganizationDetail';

function App() { 

  return (
    <>
      <Route path={absURL("/")}>
        <MainPage />
      </Route>
      <CourseSessionProvider>
      <Switch>
        <Route path={absURL("/course/:courseSessionShortId")}>
          {(params) => <CourseSessionJoin courseSessionShortId={params.courseSessionShortId} />}
        </Route>
        <Route path={absURL("/admin/all")}>
          <QuizAdminStatusProvider>
            <AdminQuizList />
          </QuizAdminStatusProvider>
        </Route>
        <Route path={absURL("/admin")}>
          <QuizAdminStatusProvider>
            <AdminGroupOverview />
          </QuizAdminStatusProvider>
        </Route>
        <Route path={absURL("/live/:quizId")}>
          {(params) => <QuizLive quizId={params.quizId} />}
        </Route>
        <Route path={absURL("/:quizAccessShortId")}>
          {(params) => 
            <QuizInstanceStatusProvider quizAccessShortId={params.quizAccessShortId}>
              <QuizWrapper />
            </QuizInstanceStatusProvider>
          }
        </Route>
        <Route path={absURL("/admin/quiz/:quizId/edit")}>
          {(params) => 
            <QuizAdminStatusProvider>
              <AdminQuizEdit quizId={params.quizId} />
            </QuizAdminStatusProvider>
          }
        </Route>
        <Route path={absURL("/admin/quiz/:quizId/questions")}>
          {(params) => 
            <QuizAdminStatusProvider>
              <QuizQuestionList quizId={params.quizId} />
            </QuizAdminStatusProvider>
          }
        </Route>
        <Route path={absURL("/admin/quiz/:quizId/instances")}>
          {(params) => 
            <QuizAdminStatusProvider>
              <AdminQuizInstanceList quizId={params.quizId} />
            </QuizAdminStatusProvider>
          }
        </Route>
        <Route path={absURL("/admin/settings")}>
          <QuizAdminStatusProvider>
            <AdminOrgSettings />
          </QuizAdminStatusProvider>
        </Route>
        <Route path={absURL("/admin/super/organizations")}>
          <QuizAdminStatusProvider>
            <AdminSuperOrganizationList />
          </QuizAdminStatusProvider>
        </Route>
        <Route path={absURL("/admin/super/organizations/:organizationId")}>
          {(params) =>
            <QuizAdminStatusProvider>
              <AdminSuperOrganizationDetail organizationId={params.organizationId} />
            </QuizAdminStatusProvider>
          }
        </Route>
        <Route path={absURL("/admin/createQuiz")}>
          <QuizAdminStatusProvider>
            <AdminQuizCreate />
          </QuizAdminStatusProvider>
        </Route>
        <Route path={absURL("/admin/quiz/:quizId/questionCreate")}>
          {(params) => 
            <QuizAdminStatusProvider>
              <AdminQuizQuestionCreate quizId={params.quizId} />
            </QuizAdminStatusProvider>
          }
        </Route>
        <Route path={absURL("/admin/quiz/:quizId/questions/:quizQuestionId")}>
          {(params) => 
            <QuizAdminStatusProvider>
              <AdminQuizQuestionEdit quizId={params.quizId} quizQuestionId={params.quizQuestionId} />
            </QuizAdminStatusProvider>
          }
        </Route>
        <Route path={absURL("/:quizAccessShortId/admin")}>
          {(params) => <QuizInstanceAdminStatusProvider quizAccessShortId={params.quizAccessShortId} />}
        </Route>
        <Route path={absURL("/:quizAccessShortId/result")}>
          {(params) => 
            <QuizInstanceAdminStatusProvider 
              quizAccessShortId={params.quizAccessShortId} 
              showResult={true} />
          }
        </Route>
      </Switch>
      </CourseSessionProvider>
    </>
  );
}

export default App;